import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { User, Calendar, Phone, Mail, Camera } from "lucide-react"
import { Card, CardContent } from "../components/ui/card.tsx"
import { ProfileLayout } from "../components/ProfileLayout"
import { getCookie, deleteCookie } from "../utils/cookies"
 
export default function ProfilePage() {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
 
  useEffect(() => {
    const savedUser = getCookie("user")
    if (savedUser && savedUser !== "undefined") {
      try { setUser(JSON.parse(savedUser)) } catch (e) { navigate("/") }
    } else {
      navigate("/")
    }
  }, [navigate])
 
  const handleLogout = () => {
    deleteCookie("user")
    deleteCookie("accessToken")
    deleteCookie("refreshToken")
    window.dispatchEvent(new CustomEvent("user-updated", { detail: null }))
    navigate("/")
  }
 
  if (!user) return null
 
  const getInitial = (name) => name?.charAt(0).toUpperCase() || "U"
 
  return (
    <ProfileLayout onLogout={handleLogout}>
      <div className="bg-gray-50 min-h-screen">
        <div className="bg-white shadow-sm border-b border-gray-200 p-6 mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Profile</h2>
        </div>
 
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <Card className="md:col-span-1">
            <CardContent className="p-6 text-center">
              <div className="relative inline-block mb-4">
                <div className="w-32 h-32 rounded-full bg-primary text-white flex items-center justify-center text-4xl font-bold">
                  {getInitial(user.name)}
                </div>
                <button className="absolute bottom-0 right-0 bg-white rounded-full p-2 shadow-lg border">
                  <Camera className="w-4 h-4 text-gray-600" />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-1">{user.name || "User"}</h2>
              <p className="text-gray-600 text-sm">Male, Years</p>
            </CardContent>
          </Card>
 
          <Card className="md:col-span-2">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold mb-6">Personal Details</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <User className="w-5 h-5 text-gray-400 mt-1" />
                  <div>
                    <p className="text-sm text-gray-600">Full Name</p>
                    <p className="font-medium">{user.name || "User"}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <User className="w-5 h-5 text-gray-400 mt-1" />
                  <div>
                    <p className="text-sm text-gray-600">Gender</p>
                    <p className="font-medium">Male</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Calendar className="w-5 h-5 text-gray-400 mt-1" />
                  <div>
                    <p className="text-sm text-gray-600">Age</p>
                    <p className="font-medium">Years</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="w-5 h-5 text-gray-400 mt-1" />
                  <div>
                    <p className="text-sm text-gray-600">Contact Number</p>
                    <p className="font-medium">{user.phone || "N/A"}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Mail className="w-5 h-5 text-gray-400 mt-1" />
                  <div>
                    <p className="text-sm text-gray-600">Email</p>
                    <p className="font-medium">{user.email || "N/A"}</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          </div>
        </div>
      </div>
    </ProfileLayout>
  )
}